import CrudTab from './CrudTab';
import styled from 'styled-components';

const CrudTabStyled = styled(CrudTab)`
  max-width: 1000px;
`;

export default CrudTabStyled;
